module.exports = __webpack_public_path__ + "media/src/img/ban-2-fdbcd620aefde0187b45dfc74dcd780d.svg";